import { forwardRef } from 'react';
import { useSSRCollectionNode } from '../collection.esm.js';

/*
 *  Ported code from react-aria-components as of V.1.2.1 use the original commit in the repo
 *  to diff any added code since the original commit.
 */
function GridListItem(props, ref) {
  return useSSRCollectionNode('item', props, ref, props.children);
}

/**
 * A GridListItem represents an individual item in a GridList.
 */
var _GridListItem = /*#__PURE__*/forwardRef(GridListItem);

export { _GridListItem as default };
//# sourceMappingURL=grid-list-item.esm.js.map
